import { render, staticRenderFns } from "./CodGroup.vue?vue&type=template&id=0d5876a5&scoped=true&"
import script from "./CodGroup.vue?vue&type=script&lang=ts&"
export * from "./CodGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CodGroup.vue?vue&type=style&index=0&id=0d5876a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5876a5",
  null
  
)

export default component.exports